import React, { useMemo } from "react";
import { connect } from "react-redux";
import { formatMessage } from "lib/globalize-util";
import { ColorInsights } from "models/insights/color-insights";
import { InlineLoading } from "components/content-loading";
import ColorInsightsTable from "./color-insights-table";
import { useStyles } from "./order-trends-colors.styles";
import { DATATEST } from "constants/integration";

// Types
interface ProductColorInsightsProps {
    productColors: ColorInsights[];
    isLoading: boolean;
}

// Main Component
const ProductColorInsights = ({ productColors, isLoading }: ProductColorInsightsProps) => {
    const classes = useStyles();

    const content = useMemo(
        () => {
            if (productColors === null || productColors.length === 0) {
                return (
                    <div data-test={DATATEST.INSIGHTS.COLOR.NO_COLORS}>
                        {formatMessage("No Color trend data available.")}
                    </div>
                );
            }

            return (
                <div>
                    <div className={classes.tabInfo} data-test={DATATEST.INSIGHTS.COLOR.INFO}>
                        {formatMessage("Data is based on all USD orders for this brand within the last 12 months.")}
                    </div>
                    <div>
                        <ColorInsightsTable productColors={productColors} />
                    </div>
                </div>
            );
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [productColors],
    );

    if (isLoading) {
        return <InlineLoading />;
    }

    return (
        <div className={classes.container}>
            <div className={classes.title}>{formatMessage("Top ordered colors")}</div>
            {content}
        </div>
    );
};

// Redux connection
const mapStateToProps = (state) => {
    return {
        productColors: state.insights.productColors,
        isLoading: state.insights.isLoading.colors,
    };
};

export const ProductColorInsightsContainer = connect(mapStateToProps, {})(ProductColorInsights);
export default ProductColorInsightsContainer;
